// frontend/src/components/ProfileBlockDisplays/StatsBlockDisplay.js
import React from 'react';

const StatsBlockDisplay = ({ content }) => {
    if (!content || !content.items || content.items.length === 0) return null;

    return (
        <div className="p-6 md:p-8 rounded-xl border border-outlineVariant bg-surface text-surface-on">
            {content.title && (
                <h3 className="text-headline-small font-bold mb-6 text-surface-on">
                    {content.title}
                </h3>
            )}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {content.items.map((item, index) => (
                    <div
                        key={index}
                        className="p-6 rounded-xl border border-outlineVariant bg-surface-containerLow text-center h-full flex flex-col justify-center"
                    >
                        <div className="text-headline-medium font-bold text-primary mb-1">
                            {item.value}
                        </div>
                        <div className="text-body-medium font-bold text-surface-onVariant">
                            {item.label}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StatsBlockDisplay;
